/**
 * Dünya mutasyon komutları.
 *
 * NEDEN: Tek kişilik oyunda dünyayı doğrudan değiştirmek kolaydır, ama çok
 * oyunculuda her değişikliğin sunucuda doğrulanıp herkese yayınlanması gerekir.
 * Tüm mutasyonlar bu tek darboğazdan geçtiği için ağ katmanı sonradan
 * ADAPTÖR olarak eklenebilir; sistemlerin yeniden yazılması gerekmez.
 *
 * Kural: World'ün durumunu değiştiren hiçbir sistem doğrudan mutasyon çağırmaz,
 * hepsi world.apply(cmd) kullanır.
 */

export type Command =
  // id: komutu ÜRETEN taraf atar ve komutla taşınır.
  // Aksi halde her istemci kendi kimliğini üretir ve "sök/yükselt" komutları
  // karşı tarafta hedefi bulamaz (çok oyunculuda durum ayrışır).
  // storageSize: yalnızca ölüm mezarı sandığı için kullanılır (normal sandık 24 sabit kalır).
  | { t: 'structure:place'; id?: string; piece: string; x: number; y: number; z: number; rotY: number; storageSize?: number; by?: string }
  | { t: 'structure:remove'; id: string; by?: string }
  | { t: 'structure:replace'; id: string; piece: string; by?: string }
  | { t: 'structure:damage'; id: string; amount: number; by?: string }
  | { t: 'structure:repair'; id: string; amount: number; by?: string }
  | { t: 'resource:harvest'; id: string; def: string; by?: string }
  | { t: 'creature:spawn'; id: string; def: string; x: number; y: number; z: number }
  | { t: 'creature:damage'; id: string; amount: number; by?: string }
  | { t: 'creature:despawn'; id: string }
  | { t: 'chest:store'; id: string; slot: number; item: string | null; count: number; dur?: number; by?: string };

export interface CommandResult {
  ok: boolean;
  /** Uygulanan komutun ürettiği veri (ör. oluşturulan yapı kimliği). */
  data?: unknown;
  reason?: string;
}

export type CommandListener = (cmd: Command, result: CommandResult) => void;

/**
 * Komut kaydedici/yayıncı.
 * Yerel oyunda yalnızca dinleyicileri bilgilendirir; ağ katmanı geldiğinde
 * aynı akış WebSocket üzerine kopyalanır.
 */
export class CommandBus {
  private listeners = new Set<CommandListener>();
  /** Uzaktan gelen komutları işlerken yeniden yayınlamayı önlemek için. */
  private replaying = false;

  onApplied(fn: CommandListener): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  get isReplaying(): boolean {
    return this.replaying;
  }

  /** Uzak komutu yerelde uygularken çağrılır: dinleyiciler tekrar ağa yollamasın. */
  replay<T>(fn: () => T): T {
    this.replaying = true;
    try {
      return fn();
    } finally {
      this.replaying = false;
    }
  }

  emit(cmd: Command, result: CommandResult): void {
    if (this.replaying) return;
    for (const fn of [...this.listeners]) {
      try {
        fn(cmd, result);
      } catch (err) {
        console.error('[CommandBus] dinleyici hatası:', err);
      }
    }
  }
}
